import type { TCorResponse } from '@/features/configuracoes/interfaces'
import { HttpService } from '@/infra'

export class GetCoresService extends HttpService {
  async execute(idExterno: number) {
    return this.http.get<TCorResponse>(`api/v2/Empreendimento/${idExterno}/corDoLote`)
  }
}
